import cx from "classnames";

// CSS
import styles from "../header.module.scss";

// Constants
const linkedinIconSrc =
    require("../../../assets/icons/linkedin-dark.svg").default;
const youtubeIconSrc =
    require("../../../assets/icons/youtube-dark.svg").default;
const logoSrc = require("../../../assets/logos/symphony-light.svg").default;


export const HeaderRowOne = (props) => {
    const { conference, goToConference, goToSocial, goToSymphony } = props;
    const { hide_featured_conference_from_nav, is_featured,  } = conference || {};

    return (
        <div className={cx(styles.row, styles["row--one"])}>
            <div
                className={cx(styles.register, {
                    [styles["register--hidden"]]:
                        !is_featured,
                })}
            >
                <a
                    className={cx(styles["register-link"], {
                        [styles["register-link--hidden"]]:
                            hide_featured_conference_from_nav,
                    })}
                    href={conference?.register_link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Register
                </a>
            </div>

            <div className={styles.featured}>
                <div
                    className={cx(styles.conference, {
                        [styles["conference--hidden"]]:
                            hide_featured_conference_from_nav,
                    })}
                    onClick={goToConference}
                >
                    <span className={styles.dateString}>
                        {conference?.date_string}
                    </span>{" "}
                    <span> {conference?.location}</span>
                </div>
                <div className={styles.socials}>
                    {/*
                    <img
                        alt="Twitter icon"
                        className={styles.icon}
                        onClick={() => goToSocial("twitter")}
                        src={twitterIconSrc} />
                    */}
                    <img
                        alt="Linkedin icon"
                        className={styles.icon}
                        onClick={() => goToSocial("linkedin")}
                        src={linkedinIconSrc}
                    />

                    <img
                        alt="Youtube icon"
                        className={styles.icon}
                        onClick={() => goToSocial("youtube")}
                        src={youtubeIconSrc}
                    />

                </div>
            </div>
            <div className={styles.logo} onClick={goToSymphony}>
                <img alt="Symphony logo" src={logoSrc} />
            </div>
        </div>
    );
};
